// extracted by mini-css-extract-plugin
module.exports = {"article":"Layout_article__nXNZK","header":"Layout_header__qPF4o","main":"Layout_main__LXt7A","footer":"Layout_footer__mro9j"};